/* # =================================================================
# sweatAlert2
#data-alert=trueで動作
＃ data-title ががconfirmのaタグに
# ================================================================= */
import Swal from 'sweetalert2';

export default function alertSwalExternalSite() {
	const hasAlertLinks = document.querySelectorAll('[data-alert="true"]');
	hasAlertLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const title = link.getAttribute('data-title');
			const url = link.getAttribute('href');
			const titleMessage = `${title}公式サイトへ移動します`;
			Swal.fire({
				title: `<span>${titleMessage}</span>`,
				icon: 'info',
				confirmButtonText: '大会公式サイトへ移動',
				confirmButtonColor: '#A0070D',
				showCancelButton: true,
				cancelButtonText: 'キャンセル',
				cancelButtonColor: '#aaa',
			}).then((result) => {
				if (result.isConfirmed) {
					window.open(url, '_blank');
				}
			});
		});
	});
}
